import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
// import Certificate from "./pages/Certificate";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import Certificates from "./pages/Certificates";
import Collection from "./components/Collection";
import Categories from "./components/Categories";
import { CategoriesSection } from "./components/ProductCategories";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/privacyPolicy";
import ProductDetails from "./pages/ProductDetails";
import LanguageSelector from "./components/LanguageSelector";


const App = () => {
  return (
    <div className="App">
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/collections" element={<Collection />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/categories" element={
          <>
            <CategoriesSection/>
          </>
        } />

        <Route path="/categories/:category" element={<Categories />} />
         <Route path="/termsofService" element={<TermsOfService />} />
         <Route path="/privacyPolicy" element={<PrivacyPolicy />} />


        {/* <Route path="/about" element={<About />} /> */}
        {/* Add other routes here */}
        <Route path="*" element={<h2>Page Not Found</h2>} />
      </Routes>

      <Footer />

      {/* Fixed Language Selector Widget */}
      <div className="translate-fixed">
        <LanguageSelector />
      </div>
    </div>
  );
};

export default App;
